export const inchesToCm = (inches) => Math.round(inches * 2.54);

export const formatSnowfall = (inches, unit = "imperial") =>
  unit === "metric" ? `${inchesToCm(inches)} cm` : `${inches}"`;
